/**
 * @generated SignedSource<<b530973bff90fff079483bdd8a37e142>>
 * @relayHash 84c2c1e346b9a26f93ec271062299f07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 990ee6cb15a97d6610be8c786bb0db24d16f77a6df01554ca9f374ec6a6a765b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookTemplateCreateQuery } from './PlaybookTemplateCreateQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookTemplateCreateQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "990ee6cb15a97d6610be8c786bb0db24d16f77a6df01554ca9f374ec6a6a765b",
    "metadata": {},
    "name": "PlaybookTemplateCreateQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
